import React from 'react';
import { Container, Flex, Grid, Text, Link, Stack } from 'basis';
import { PdfIcon, StyledUL } from 'components';
import { DocUpload } from 'doc-upload';
import { byCountry, generateUploadConfig, isDJ } from 'utils';
import { useTheme } from '@emotion/react';
import { content } from './content';

export const UploadBankStatements = ({ applicationRef, handleDocUploadEvent, channel }) => {
  const theme = useTheme();
  const config = generateUploadConfig({
    applicationRef,
    channel,
    documentSubType: 'BANK_STATEMENT',
    handleDocUploadEvent,
    validationRules: {
      maxFiles: 15,
      maxFileSize: 5 * 1024 * 1024,
      maxTotalSize: 22 * 1024 * 1024,
      allowedFileTypes: ['pdf'],
    },
    content: {
      upload: {
        fileRules:
          '<small>PDF format only. Max file size: 5 MB (5,242 KB) each.<br />Total upload limit: 22 MB (22,528 KB).</small>',
      },
    },
    theme: {
      textColor: isDJ() ? theme.colors.textBodyColor : theme.colors.indigo,
      linkColor: theme.a.color,
    },
  });
  const contentByCountry = byCountry(content);
  return (
    <Stack gap="8">
      <Flex padding="0 0 6 0">
        <>
          <PdfIcon width="49" height="61" viewBox="0 0 49 61" />
          <Text margin="0 0 0 6">For fast processing, upload your bank statements in PDF file format.</Text>
        </>
      </Flex>
      <Container padding="0" margin="0">
        <Grid preset="page" rowsGap={6}>
          <Grid.Item colSpan="all">
            <Text>
              <strong>All documents must contain your full legal name.</strong>
            </Text>
          </Grid.Item>
          <Grid.Item colSpan="all">
            <StyledUL marginTop="-8px">
              {contentByCountry.bankStatements.items.map((item, index) => (
                <li key={`bank-statement-item-${index}`}>{item}</li>
              ))}
            </StyledUL>
          </Grid.Item>
          <Grid.Item colSpan="all">
            <DocUpload {...config} />
          </Grid.Item>
          <Grid.Item colSpan="all">
            <Text textStyle="body2">
              By clicking 'Submit' you agree to the{' '}
              <Link
                href={byCountry({
                  AU: 'https://bankstatements.com.au/about/terms',
                  NZ: 'https://www.bankstatements.co.nz/about/terms',
                })}
                newTab
              >
                Illion's Bank Statements Terms & Conditions
              </Link>{' '}
              and{' '}
              <Link
                href={byCountry({
                  AU: 'https://www.experian.com.au/privacy-policy-terms-conditions',
                  NZ: 'https://www.experian.co.nz/privacy-policy',
                })}
                newTab
              >
                Privacy Policy.
              </Link>
            </Text>
          </Grid.Item>
        </Grid>
      </Container>
    </Stack>
  );
};
